export const numberFormat = (value) =>
  new Intl.NumberFormat('id-ID', {
    style: 'decimal',
  }).format(value);
